import { CustomSettingGuard } from '@components/customSettingGuard';
import { ProtectedRoute } from '@components/protectedRoute';
import { appRoutes } from '@utils/consts';
import { parseRoute } from '@utils/i18n';

export const hotSeatRoutes = [
  {
    path: appRoutes.hotSeat,
    lazy: async () => {
      const { HotSeat } = await import('@pages/hotSeat');
      const { HotSeatProvider } = await import('@contexts/hotSeat');
      return {
        Component: () => (
          <ProtectedRoute>
            <CustomSettingGuard
              disabledBy="hot_seat_view_disabled"
              redirectTo={parseRoute(appRoutes.index)}>
              <HotSeatProvider>
                <HotSeat />
              </HotSeatProvider>
            </CustomSettingGuard>
          </ProtectedRoute>
        ),
      };
    },
  },
];
